import { apiClient } from '@/lib/api-client';
import {
  API_ENDPOINTS,
  WaitlistCreateRequest,
  WaitlistResponse,
  WaitlistStatus,
  WaitlistUnsubscribeRequest,
} from '@/types/api';

export const waitlistApi = {
  // Add email to waitlist
  create: async (data: WaitlistCreateRequest): Promise<WaitlistResponse> => {
    return apiClient.post<WaitlistResponse>(API_ENDPOINTS.waitlist.create, data);
  },

  // Check if email is in waitlist
  checkStatus: async (email: string): Promise<WaitlistStatus> => {
    return apiClient.get<WaitlistStatus>(API_ENDPOINTS.waitlist.checkStatus, {
      params: { email },
    });
  },

  // Remove email from waitlist
  unsubscribe: async (data: WaitlistUnsubscribeRequest): Promise<WaitlistResponse> => {
    return apiClient.post<WaitlistResponse>(API_ENDPOINTS.waitlist.unsubscribe, data);
  },
};